// navConfig.ts or similar
import { ROUTE_KEYS } from 'utils/constants';
import { ReactComponent as BrandDetailsIcon } from 'assets/icons/brand-details.svg';
import { ReactComponent as OpeningTimeIcon } from 'assets/icons/opening-time.svg';
import { LocationIcon } from 'cokitchen-icons';

export const getCareerDetailsNav = (search = '') => [
  {
    title: 'Job details',
    link: `${ROUTE_KEYS.CREATE_POSITION}/${ROUTE_KEYS.CREATE_POSITION_FORM_DETAILS}${search}`,
    Icon: BrandDetailsIcon
  },
  {
    title: 'Job description',
    link: `${ROUTE_KEYS.CREATE_POSITION}/${ROUTE_KEYS.CREATE_POSITION_FORM_DESCRIPTION}${search}`,

    Icon: OpeningTimeIcon
  },
  {
    title: 'Application settings',
    link: `${ROUTE_KEYS.CREATE_POSITION}/${ROUTE_KEYS.CREATE_POSITION_FORM_APP_SETTINGS}${search}`,

    Icon: OpeningTimeIcon
  },
  {
    title: 'Preview',
    link: `${ROUTE_KEYS.CREATE_POSITION}/${ROUTE_KEYS.CREATE_POSITION_FORM_PREVIEW}${search}`,

    Icon: LocationIcon
  }
];
